var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"loading",on:{"touch":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"icon"},[_vm._v(" 转圈 ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }